<template>
  <app-modal
    :modal-id="modalId"
    :title="title"
    :preloader="preloader"
    @close-modal="closeModal"
    modal-size="extra-large"
    modal-alignment="top"
  >
    <template slot="header">
      <h5 class="modal-title">{{ title }}</h5>
      <button
        type="button"
        class="close outline-none"
        data-dismiss="modal"
        aria-label="Close"
      >
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
      </button>
    </template>

    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <FullCalendar
        ref="fullCalendar"
        defaultView="dayGridMonth"
        :options="calendarOptions"
        :header="{
          left: 'prev,next today',
          center: 'title',
          right: 'dayGridMonth,timeGridWeek,timeGridDay,listWeek',
        }"
        :plugins="calendarPlugins"
        :weekends="calendarWeekends"
        :events="events"
        @eventClick="handleEventClick"
        :editable="true"
        navLinks="true"
        locale="es"
      />
    </template>

    <template slot="footer">
      <button
        type="button"
        class="btn btn-secondary mr-2"
        data-dismiss="modal"
        @click="closeModal"
      >
        Cerrar
      </button>

      <edit-evaluation-modal
      v-if="isEditModalActive"
      :selected-url="selectedUrl"
      :evaluation="evaluation"
      :habilite-form="habiliteForm"
      :plannification-data="plannificationData"
      :evaluators-lider-list="evaluatorsLiderList"
      :lider-evaluator-training-list="liderEvaluatorTrainingList"
      :evaluator-list="evaluatorList"
      :evaluators-training-list="evaluatorsTrainingList"
      :observer-list="observerList"
      :technical-expert-list="technicalExpertList"
      @close-modal="closeEditModal"
    />
    </template>
  </app-modal>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import { ModalMixin } from "@/app/Mixins/ModalMixin";
import { quillEditor } from "vue-quill-editor";
import { axiosGet } from "@/app/helpers/AxiosHelper";
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import "@fullcalendar/core/main.css";
import "@fullcalendar/daygrid/main.css";
import "@fullcalendar/timegrid/main.css";

export default {
  mixins: [FormMixin, ModalMixin],
  components: { FullCalendar },
  props: {
    tableId: String,
    modalTitle: String,
    evaluationId: String,
  },
  data() {
    return {
      preloader: false,
      loaded: false,
      inputs: {},
      modalId: "modal-calendar-edit",
      events: "",
      /* Full Calendar Options Start */

      calendarPlugins: [dayGridPlugin, interactionPlugin],
      calendarWeekends: true,
      // calendarEvents: {
      //   url: '/accreditationtechnical/planningteam/evaluationList'
      // },
      calendarOptions: {
        eventLimit: true,
        views: {
          timeGrid: {
            eventLimit: 4,
          },
          monthGrid: {
            eventLimit: 4,
          },
          dayGrid: {
            eventLimit: 4,
          },
        },
      },
      /* Full Calendar Options End */
      evaluation: Object,
      habiliteForm: false,
      plannificationData: [],
      evaluatorsLiderList: [{ id: "", value: "Selecciona una opción" }],
      liderEvaluatorTrainingList: [{ id: "", value: "Selecciona una opción" }],
      evaluatorList: [{ id: "", value: "Selecciona una opción" }],
      evaluatorsTrainingList: [{ id: "", value: "Selecciona una opción" }],
      observerList: [{ id: "", value: "Selecciona una opción" }],
      technicalExpertList: [{ id: "", value: "Selecciona una opción" }],
      isEditModalActive: false,
    };
  },
  computed: {
    title() {
      return this.selectedUrl ? this.editModalTitle : this.modalTitle;
    },
  },
  created() {
    if (this.selectedUrl) {
      this.preloader = true;
    } else {
      this.loaded = true;
    }
  
    this.getEvaluatorsLiderList();
    this.evaluationData();
    this.getEvents();
  },
  methods: {
    evaluationData() {
      this.preloader = true;
      let selectedUrl = `/accreditationtechnical/planningteam/planningData/${this.evaluationId}`;
      this.axiosGet(selectedUrl).then((response) => {
        this.evaluation = response.data.evalTest;
        this.preloader = false;
      });
    },
    getEvaluatorsLiderList() {
      var selectedUrl = `/accreditationtechnical/planningteam/evaluatorsLiderList`;
      axios.get(selectedUrl).then((response) => {
        this.evaluatorsLiderList = [
          { id: "", value: "Seleccione un evaluador" },
          ...response.data.evaluators,
        ];

        this.liderEvaluatorTrainingList = [
          { id: "", value: "Seleccione un evaluador" },
          ...response.data.lider_evaluator_training,
        ];

        this.evaluatorList = [
          { id: "", value: "Seleccione un evaluador" },
          ...response.data.evaluator,
        ];

        this.evaluatorsTrainingList = [
          { id: "", value: "Seleccione un evaluador" },
          ...response.data.evaluator_training,
        ];

        this.observerList = [
          { id: "", value: "Seleccione un evaluador" },
          ...response.data.observator,
        ];
        console.log(this.observerList);

        this.technicalExpertList = [
          { id: "", value: "Seleccione un evaluador" },
          ...response.data.technical_experts,
        ];
      });
    },
    getEvents() {
      axios
        .get(`/accreditationtechnical/planningteam/evaluationList?evalTest=${this.evaluationId}`)
        .then(
          (resp) => ((this.events = resp.data.data), (this.preloader = false))
        )
        .catch((err) => console.log(err.response.data));
    },
    handleEventClick(e) {
      var selectedUrl = `/accreditationtechnical/planningteam/showEvaluation/${e.event.id}`;
      
      axios.get(selectedUrl).then((response) => {
        this.plannificationData = response.data;
    
        if (
          this.plannificationData.evaluation.id == Number(this.evaluationId)
        ) {
          this.habiliteForm = true;
          this.isEditModalActive = true;
          this.current_event = e.event;
          this.show_event_details_modal = true;
        } else {
          this.habiliteForm = false;
          this.isEditModalActive = true;
          this.current_event = e.event;
          this.show_event_details_modal = true;
        
        }
      });
    },
    closeEditModal() {
      $("#asign-edit-modal").modal("hide");
      this.isEditModalActive = false;
    },
  },
};
</script>
<style>
.color-req {
  color: red;
}

.space {
  margin-top: 100px;
}
</style>
